export const POST_TERMS_DASHBOARD_PATH = '/dashboard/home';
export const POST_TERMS_GUIDED_EXPERIENCE_PARAM = 'guidedExpirience';

export const POST_TERMS_DASHBOARD_PARAMS = {
  comingFrom: 'onboarding',
  [POST_TERMS_GUIDED_EXPERIENCE_PARAM]: true,
} as const;
